module.exports = __webpack_public_path__ + "img/lens-174-plus-00.1fc49b12.png";